
export const PERIOD_TIME_UNIT = [
    { id: 1, name: "day", key: "DAYS" },
    { id: 2, name: "month", key: "MONTHS" },
    { id: 3, name: "year", key: "YEARS" }
]

/**
 * Enum defined in the backend
 */
export const PERIOD_TIME_UNIT_ENUM = {
    HOURS: {
        id: 0,
        name: "HOURS",
        key: "hour",
        trans: "hours"
    },
    DAYS: {
        id: 1,
        name: "DAYS",
        key: "day",
        trans: "days"
    },
    WEEKS: {
        id: 2,
        name: "WEEKS",
        key: "week",
        trans: "weeks"
    },
    MONTHS: {
        id: 3,
        name: "MONTHS",
        key: "month",
        trans: "months_label"
    },
    YEARS: {
        id: 4,
        name: "YEARS",
        key: "year",
        trans: "years"
    }
}


